import React from 'react';
import { DtpSpinner } from 'dtp-react-components';

const Spinner = props => (
  <DtpSpinner {...props} />
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/Spinner.jsx